import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=651acd9f&scoped=true&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"
import style0 from "./Todo.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"
import style1 from "./Todo.vue?vue&type=style&index=1&id=651acd9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651acd9f",
  null
  
)

component.options.__file = "Todo.vue"
export default component.exports